import { useState } from "react";

export const useVocabNavigation = (totalWords) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % totalWords);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? totalWords - 1 : prevIndex - 1
    );
  };

  const resetIndex = () => {
    setCurrentIndex(0);
  };

  return {
    currentIndex,
    handleNext,
    handlePrev,
    resetIndex,
  };
};
